// index.ts
import { useCallback, useMemo, useRef, useState } from "react";
function useHtmlDialog(options) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const show = useCallback(() => {
    var _a;
    (_a = ref.current) == null ? void 0 : _a.show();
    setIsOpen(true);
  }, []);
  const showModal = useCallback(() => {
    var _a;
    (_a = ref.current) == null ? void 0 : _a.showModal();
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    var _a;
    (_a = ref.current) == null ? void 0 : _a.close();
    setIsOpen(false);
  }, []);
  const dialogElementProps = useMemo(() => {
    const onClick = e => {
      if ((options == null ? void 0 : options.closeOnOutsideClick) === false) {
        return;
      }
      if (e.target === ref.current) {
        close();
      }
    };
    const onKeyDown = e => {
      if (e.key === "Escape") {
        close();
      }
    };
    const style = (options == null ? void 0 : options.resetStyles) === false ? void 0 : {
      padding: 0,
      border: "none",
      background: "transparent"
    };
    return {
      ref,
      style,
      onClick,
      onKeyDown
    };
  }, [options, close]);
  return {
    ref,
    show,
    showModal,
    close,
    props: dialogElementProps,
    isOpen
  };
}
export { useHtmlDialog };